import React, { useState, useEffect } from 'react';
import { useStyles } from './NoConsentCookieContainer.styles';
import { theme } from 'theme/App.theme';
import {
  LinkButton,
  LinkButtonType,
} from 'components/Global/LinkButton/LinkButton';
import TextRender from 'components/Global/TextRender/TextRender';

interface NoConsentCookieContainerProps {}

const defaultMessage = 'To view the map, please allow Functional Cookies.';
const defaultButtonText = 'Manage Cookie Preferences';
const oneTrustModalId = 'onetrust-pc-sdk';
const noConsentMessageId = 'no-consent-message';

export const NoConsentCookieContainer: React.FC<
  NoConsentCookieContainerProps
> = () => {
  const classes = useStyles();
  const [message, setMessage] = useState(defaultMessage);
  const [buttonText, setButtonText] = useState(defaultButtonText);
  const isHonda = process.env.REACT_APP_THEME === 'honda';

  useEffect(() => {
    setMessage(window.OneTrustC0003UserConsentMessage ?? defaultMessage);
    setButtonText(window.OneTrustOpenModalCTAText ?? defaultButtonText);
  }, []);

  const openPreferenceCenter = () => {
    window.OneTrust?.ToggleInfoDisplay();
  };

  return (
    <div className={classes.container}>
      <p
        className={`${classes.paragraph} ${isHonda ? 'm_text heading-3' : ''}`}
        id={noConsentMessageId}
      >
        {message}
      </p>
      <LinkButton
        classNames={{
          container: `${classes.openCookieCTA}`,
        }}
        variant={isHonda ? LinkButtonType.evAutos : LinkButtonType.redOutlined}
        onClick={openPreferenceCenter}
        isExternal={false}
        ariaProps={{
          'aria-haspopup': 'dialog',
          'aria-controls': oneTrustModalId,
          'aria-labelledby': noConsentMessageId,
        }}
      >
        <TextRender text={buttonText} />
      </LinkButton>
    </div>
  );
};
